import { defineComponent } from "@vue/composition-api";
import { tokenize, registerPlugin, init } from "linkifyjs";
import plugin from "linkifyjs/plugins/mention";
import { RenderContext } from "vue";
import { IS_BROWSER } from "@/lib/browserUtils";
import config from "@/config";
registerPlugin("mentionPlugin", plugin);
init();

interface Props {
  mentions: boolean;
  links: boolean;
  externalLinks: boolean;
  text: string;
}

export default defineComponent({
  name: "LinkifiedText",
  functional: true,
  props: {
    mentions: { type: Boolean, default: true },
    links: { type: Boolean, default: true },
    externalLinks: { type: Boolean, default: true },
    text: { type: String, require: true },
  },
  render(h, { data, listeners, props }: RenderContext<Props>) {
    const splitText = tokenize(props.text);
    const allowExternalLinks = props.externalLinks && config.featureClickableUserExternalLinks;

    const nodes = splitText.map((token: any) => {
      if (token.t === "mention" && props.mentions) {
        return h("router-link", { props: { to: { name: "profile", params: { username: token.v.substring(1) } } } }, [
          token.v,
        ]);
      }
      const host = IS_BROWSER ? window.location.host : this.$ssrContext.host;
      if (token.t === "url" && props.links && (allowExternalLinks || token.v.includes(host.replace(/.*www./, "")))) {
        const prefix = !token.v.toLowerCase().startsWith("http") ? "http://" : "";
        return h("a", { class: ["link", "__underline"], attrs: { href: `${prefix + token.v}`, target: "_blank" } }, [
          token.v,
        ]);
      }

      return token.v;
    });

    return h("div", { ...data, on: listeners }, nodes);
  },
});
